//Functional component for the toolbar, which is a list of buttons to edit the graph. It is fixed in the top right corner of the screen.
import {DropDownItem} from "./DropDown";
import React, {useEffect, useState} from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import StartIcon from '@mui/icons-material/Start';
import {IconButton} from "@mui/material";
import './toolBar.css';

const ToolBar = (props) => {
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (!props.openToolBar) {
            setIsAnimating(true);
            setTimeout(() => setIsAnimating(false), 500);
        }
    }, [props.openToolBar]);

    if (!props.openToolBar && !isAnimating) return null;
    return (
        <div
            className={`flex flex-col justify-end border-l-2 border-b-2 border-neutral-700 dark:border-neutral-900 items-end bg-neutral-300 dark:bg-neutral-900 pr-2 top-0 pl-6 right-0 z-10 absolute rounded-bl-lg ${props.openToolBar ? 'open' : 'closed'}`}>

            <div className="absolute top-6 left-0 opacity-90">
                <IconButton size="small" aria-label="delete" onClick={props.toolBarToggle}>
                    <StartIcon fontSize="small"/>
                </IconButton>
            </div>
            <DropDownItem name={"Add Vertex"}
                          toggable={true}
                          disabled={!props.editMode}
                          isActive={props.addingNode}
                          onClick={e => props.setAddingNode(!props.addingNode)}
                          leftIcon={<AddCircleOutlineIcon fontSize="small"></AddCircleOutlineIcon>}></DropDownItem>
            {props.selectedTab === "social" &&
                <DropDownItem name={"Add Edge"}
                              toggable={true}
                              isActive={props.addingEdge}
                              onClick={e => {
                                  props.setAddingEdge(!props.addingEdge)
                              }}
                              disabled={!props.editMode}
                              leftIcon={<AddCircleOutlineIcon fontSize="small"></AddCircleOutlineIcon>}></DropDownItem>
            }
            {props.selectedTab === "spatial" &&
                <DropDownItem name={"Move Vertex"}
                              toggable={true}
                              disabled={!props.editMode}
                              isActive={props.movingNode}
                              onClick={e => props.setMovingNode(!props.movingNode)}
                              leftIcon={<AddCircleOutlineIcon fontSize="small"></AddCircleOutlineIcon>}></DropDownItem>
            }
        </div>
    )
}

export default ToolBar;